import { useTheme } from "@mui/material"
import { FC } from "react"
import { Link } from "react-router-dom"

interface IProps {
  to: string
  text: string | JSX.Element
  sx?: any
}

const AnchorButton: FC<IProps> = ({to, text, sx}) => {
  const theme = useTheme()

  return (
    <Link to={to} style={{textDecoration: 'none', color: theme.palette.primary.main, ...sx}}>{text}</Link>
  )
}
export default AnchorButton
